import { Provider } from 'react-redux';
import { store } from '@/store';
import DynamicThemeProvider from '@/components/providers/ThemeProvider';
import AppRoutes from '@/routes';
import AppInitializer from '@/components/common/AppInitializer';
import '@/styles/globals.css';

function App() {
  return (
    <Provider store={store}>
      <DynamicThemeProvider>
        <AppInitializer>
          <AppRoutes />
        </AppInitializer>
      </DynamicThemeProvider>
    </Provider>
  );
}

export default App;